import { useCallback } from 'react';
import type { ActionHandlerType } from '../../../../context/ActionsProvider/context';
import { SHOULD_NOT_PROPAGATE_UP } from '../../const';
import {
  useEnrollBiometrics,
  useRevokeBiometrics,
  useVerifyBiometrics,
} from './hooks/useBiometric';
import type { BiometricsMethodType } from './schema/manageBiometrics';

export type ManageBiometricsActionPayload = {
  method: BiometricsMethodType;
};

const useManageBiometricsAction = () => {
  const { enroll } = useEnrollBiometrics();
  const { revoke } = useRevokeBiometrics();
  const { verify } = useVerifyBiometrics();

  const onBiometricAction: ActionHandlerType = useCallback(
    async ({ action }) => {
      const payload = action.payload as ManageBiometricsActionPayload;

      switch (payload.method) {
        case 'enroll':
          await enroll();
          break;
        case 'revoke':
          await revoke();
          break;
        case 'verify':
          await verify();
          break;
        default:
          break;
      }

      return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
    },
    [enroll, revoke, verify],
  );

  return { onBiometricAction };
};

export default useManageBiometricsAction;
